import { render } from "./windForecast.vue?vue&type=template&id=51388677"
import script from "./windForecast.vue?vue&type=script&lang=js"
export * from "./windForecast.vue?vue&type=script&lang=js"

import "./windForecast.vue?vue&type=style&index=0&id=51388677&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__